import styled from 'styled-components';

export const StyledCardWrapper = styled.div`
  background: #fff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  widht: 100%;
  height: 100%;
`;
